import { render, staticRenderFns } from "./OtherManage.vue?vue&type=template&id=1200f3f1&scoped=true&"
import script from "./OtherManage.vue?vue&type=script&lang=js&"
export * from "./OtherManage.vue?vue&type=script&lang=js&"
import style0 from "./OtherManage.vue?vue&type=style&index=0&id=1200f3f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200f3f1",
  null
  
)

export default component.exports